<template>
  <div id="app">
    <!-- 移动端头部 -->
    <div v-if="showMenus" class="mobile-menus" :class="{'opened-menus':openedMenus}">
      <div v-for="(route,index) in menuRoutes" :key="index" class="mobile-menus-item"
        :class="{'mobile-active':$route.path==route.path}" @click="$router.push(route.path);openedMenus=false">{{$t(`common.${route.meta.i18n}`)}}</div>
    </div>
    <div v-if="isMobile" class="posDiv nav">
      <h1 class="flex-box">
        <img class="logo mobile-logo" src="https://www.cheyifu.com.cn/static/img/logo_cyf.jpg" alt="车易付logo">
      </h1>
      <div class="code mobile-code">
        <div>873063</div>
        <div style="width: 20vw !important;">{{ $t('common.stockCode') }}</div>
      </div>
      <LanguageSwitch />
      <div class="mobile-menus-btn" @click="handleMenus"></div>
    </div>
    <!-- PC头部 -->
    <div v-else class="posDiv nav">
      <h1 class="flex-box">
        <img class="logo" src="https://www.cheyifu.com.cn/static/img/logo.jpg" alt="车易付logo">
      </h1>
      <div class="code">
        <div>873063</div>
        <div>{{ $t('common.stockCode') }}</div>
      </div>
      <div class="menus-wrap">
        <div v-for="route in menuRoutes" :key="route.path" class="menus-item"
          :class="{'active':$route.path==route.path,'en-menu-item':language == 'en-US'}" @click="$router.push(route.path)"
          @mouseenter="handleMouseEnter(route)">{{$t(`common.${route.meta.i18n}`)}}</div>
      </div>
      <div class="login" v-show="language == 'zh-CN'" @click="toCyf">{{ $t('common.login') }}</div>
      <LanguageSwitch />
    </div>
    <div class="menus-box flex-start" v-if="path == '/product'">
      <div class="tabs">
        <div class="tab" :class="{'tab-active':currentIndex==1}" @click="changeTab(1)">{{ $t('common.smartParking') }}</div>
        <div class="tab" :class="{'tab-active':currentIndex==2}" @click="changeTab(2)">{{ $t('common.smartCharging') }}</div>
        <div class="tab" :class="{'tab-active':currentIndex==3}" @click="changeTab(3)" v-show="language == 'zh-CN'">{{ $t('common.mobileApp') }}</div>
        <div class="tab" :class="{'tab-active':currentIndex==4}" @click="changeTab(4)">{{ $t('common.smartHardware') }}</div>
      </div>
      <div class="content" v-if="currentIndex==1 || currentIndex==2 || currentIndex==3">
        <div class="con link" v-if="currentIndex==1" @click="toPage('/product')">
          <img src="./assets/images/park-icon.png"
            alt="车易付拥有车牌识别、道闸、高速道闸、无人值守、城市停车、智慧城市、智慧停车、道闸一体机、车牌识别一体机、停车收费设备、城市停车平台、智慧停车管理系统、车牌识别软件、车牌识别收费系统"
            class="top-icon">
          {{ $t('common.smartParkingSystem') }}
        </div>
        <div class="con link" v-if="currentIndex==2" @click="toPage('/productCharge')">
          <img src="./assets/images/charge-icon.png"
            alt="车易付拥有充电桩、自行车充电桩、汽车充电桩、快充充电桩、慢充充电桩、液冷充电桩、超充站、充电站、光储充、光储充一体化、光伏充电、储能、城市充电平台、停充一体化平台、充电桩投资、充电站投资、充电桩加盟、充电桩多少钱、充电桩多久充满电、充电站合作、家用充电桩。"
            class="top-icon">
          {{ $t('common.smartChargingSystem') }}
        </div>
        <div class="con link" v-if="currentIndex==3" @click="toPage('/productApplet')">
          <img src="./assets/images/applet-icon.png" alt="北京车易付科技股份有限公司拥有易停车、e停宝" class="top-icon">
          {{ $t('common.eParking') }}
        </div>
      </div>
      <div class="content" v-else>
        <div class="box1">
          <div class="title">{{ $t('common.parkingHardware') }}</div>
          <div class="dec">
            <div class="item link" @click="toHarware(1)">{{ $t('common.enclosedParking') }}</div>
            <div class="item link" @click="toHarware(2)">{{ $t('common.parkingGuidance') }}</div>
            <div class="item link" @click="toHarware(3)">{{ $t('common.roadsideParking') }}</div>
          </div>
        </div>
        <div class="box1">
          <div class="title">{{ $t('common.chargingHardware') }}</div>
          <div class="dec">
            <div class="item link" @click="toPage('/productChargeHw')">{{ $t('common.chargingProducts') }}</div>
          </div>
        </div>
        <div v-show="language == 'zh-CN'" class="box1">
          <div class="title">{{ $t('common.accessControlHardware') }}</div>
          <div class="dec">
            <div class="item link" @click="toPage('/productAcs')">{{ $t('common.accessControlProducts') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="menus-box flex-start" v-if="path == '/service' && language == 'zh-CN'">
      <div class="tabs">
        <div class="tab" :class="{'tab-active':currentIndex==1}" @click="changeTab(1)">{{ $t('common.aboutUs') }}</div>
        <div class="tab" :class="{'tab-active':currentIndex==2}" @click="changeTab(2)">{{ $t('common.downloadCenter') }}</div>
        <div class="tab" :class="{'tab-active':currentIndex==3}" @click="changeTab(3)">{{ $t('common.contactUs') }}</div>
      </div>
      <div class="content" v-if="currentIndex==1 || currentIndex==2 || currentIndex==3">
        <div class="con link" v-if="currentIndex==1" @click="toPage('/company')">
          <img src="./assets/images/company-icon.png" alt="北京车易付科技股份有限公司简介" class="top-icon">
          {{ $t('common.companyProfile') }}
        </div>
        <div class="con link" v-if="currentIndex==2" @click="toPage('/information')">
          <img src="./assets/images/download-icon.png" alt="北京车易付科技股份有限公司资料下载" class="top-icon">
          {{ $t('common.downloadMaterials') }}
        </div>
        <div class="con link" v-if="currentIndex==3" @click="toPage('/service')">
          <img src="./assets/images/phone-icon.png" alt="北京车易付科技股份有限公司联系方式" class="top-icon">
          {{ $t('common.contactInfo') }}
        </div>
      </div>
    </div>
    <div class="menus-box flex-start" v-if="path == '/platform'">
      <div class="tabs">
        <div class="tab" :class="{'tab-active':currentIndex==1}" @click="changeTab(1)">{{ $t('common.scenarioSolutions') }}</div>
      </div>
      <div class="content">
        <div class="box1">
          <div class="dec">
            <div class="item link" @click="toPage('/platform')">
              <img src="./assets/images/plateform1.png" alt="北京车易付科技股份有限公司停充一体运营增收方案" class="top-icon">
              {{ $t('common.parkingChargingSolution') }}
            </div>
          </div>
        </div>
        <div class="box1">
          <div class="dec">
            <div class="item link" @click="toPage('/platformCloud')">
              <img src="./assets/images/plateform2.png" alt="北京车易付科技股份有限公司停车场无人值守云托管方案" class="top-icon">
              {{ $t('common.unmannedParkingSolution') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- PC头部 -->
    <router-view @mouseenter="closeMenus"></router-view>
    <div class="footer">
      <div class="footer-top">
        <div class="footer-top-left">
          <h1 class="footer-title">{{ $t('common.companyName') }}</h1>
          <div class="">{{ $t('common.phone') }}<span class="footer-label">400-623-9981</span></div>
          <div class="">{{ $t('common.email') }}<span class="footer-label">cheyifu@cheyifu.com.cn</span></div>
          <div class="">{{ $t('common.address') }}<span class="footer-label">{{ $t('common.addressDetail') }}</span></div>
        </div>
        <div v-if="!isMobile">
          <div class="footer-title">{{ $t('common.productCenter') }}</div>
          <div class="cursor" @click="toPage('/product')">{{ $t('common.smartParking') }}</div>
          <div class="cursor" @click="toPage('/productCharge')">{{ $t('common.smartCharging') }}</div>
          <div class="cursor" @click="toPage('/productAcs')">{{ $t('common.accessControl') }}</div>
        </div>
        <div v-if="!isMobile">
          <div class="footer-title">{{ $t('common.aboutUs') }}</div>
          <div class="cursor" @click="toPage('/company')">{{ $t('common.companyProfile') }}</div>
          <div class="cursor" @click="toPage('/information')">{{ $t('common.downloadMaterials') }}</div>
          <div class="cursor" @click="toPage('/service')">{{ $t('common.contactInfo') }}</div>
        </div>
        <div v-if="!isMobile && language == 'zh-CN'">
          <div class="footer-title">{{ $t('common.followUs') }}</div>
          <img src="./assets/images/e.png" alt="e停宝小程序码" class="wx-img">
          <div style="text-align: center;">{{ $t('common.officialAccount') }}</div>
        </div>
      </div>
      <div class="footer-bot">
        <img class="footer-beian" src="./assets/images/beian.png" alt="公安logo"> {{ $t('common.beianInfo') }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('common.icpInfo') }}
      </div>
    </div>
    <div class="service-box flex-column">
      {{ $t('common.serviceHotline') }}
    </div>
    <div class="service-tel flex-center">400-623-9981</div>
    <div class="back-top" id="backTop" @click="backTop"></div>
  </div>
</template>
<script>
  import { mapState, menus } from 'vuex'
  import { routes } from './router'
  import LanguageSwitch from './components/LanguageSwitch.vue'

  export default {
    components: {
      LanguageSwitch
    },
    data() {
      return {
        showSelect: false,
        showMenus: true,
        openedMenus: false,
        currentIndex: 1,
        isShow: false,
        path: '',
        mediaQuery: null
      }
    },
    computed: {
      ...mapState(['menus', 'isMobile']),
      menuRoutes() {
        if (this.language == 'zh-CN') {
          return routes.filter(item => !item.hidden)
        } else {
          return routes.filter(item => item.enIsShow && !item.hidden)
        }
      },
      language() {
        return this.$i18n.locale
      }
    },
    created() {
      this.mediaQuery = window.matchMedia("(max-width: 768px)");
      this.$store.dispatch('updateIsMobile', this.mediaQuery.matches);
      // 监听媒体查询变化
      this.mediaQuery.addEventListener("change", this.handleMediaQueryChange);
    },
    beforeUnmount() {
      // 移除事件监听
      window.removeEventListener('scroll', this.handleScroll);
      if (this.mediaQuery) {
        this.mediaQuery.removeEventListener('change', this.handleMediaQueryChange);
      }
    },
    methods: {
      handleMediaQueryChange(e) {
        this.$store.dispatch('updateIsMobile', e.matches);
      },
      toHarware(currentIndex) {
        this.path = '',
          window.localStorage.setItem('currentIndex', currentIndex)
        this.$router.push("/productClose")
      },
      changeTab(index) {
        this.currentIndex = index
      },
      toCyf() {
        window.open(`https://www.cheyifu.com.cn/cloud/login`)
      },
      handleMouseEnter(route) {
        this.path = route.path
      },
      closeMenus() {
        this.path = '',
          this.currentIndex = 1
      },
      handleScroll() {
        const backElem = document.getElementById('backTop')
        if (document.documentElement.scrollTop > 0) {
          backElem.classList.remove('back-top-hidden')
        } else {
          backElem.classList.add('back-top-hidden')
        }
      },
      backTop() {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth' // 可选，平滑滚动效果
        });
      },
      toPage(url) {
        this.$router.push(url)
        this.path = ''
        this.currentIndex = 1
      },
      handleMenus() {
        this.openedMenus = !this.openedMenus
      }
    }
  }
</script>
<style lang="scss" scoped>
  #app {
    width: 100%;
  }

  .back-top {
    position: fixed;
    right: 114px;
    bottom: 100px;
    width: 120px;
    height: 120px;
    background: #E63047 url(./assets/images/top.png) center no-repeat;
    background-size: 36px 44px;
    border-radius: 16px;
    cursor: pointer;
    transform-origin: center bottom;
    transition: all 0.3s;
  }

  .back-top-hidden {
    transform: scaleY(0);
  }

  .posDiv {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    padding: 0 0 0.5vh 10vw;
    width: 100%;
    height: 7.4vh;
    color: rgba(119, 119, 119, 1);
    background: rgba(255, 255, 255);
    z-index: 9999;
  }

  .cursor {
    cursor: pointer;
  }

  .logo {
    margin-right: 1.6vw;
    width: 4.2vw;
  }

  .code {
    margin-top: 0.4vh;
    font-size: 28px;
    color: #4E5969;
    text-align: center;
  }

  .login {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    margin-right: 12.5vw;
    width: 6.25vw;
    height: 2vw;
    color: #0F46FF;
    font-weight: 500;
    border-radius: 2vw;
    border: 2px solid #0F46FF;
    cursor: pointer;
  }

  .login:hover {
    background: #E7EDFF;
  }

  .login:active {
    background: #CFDAFF;
  }

  .menus-wrap {
    margin-right: auto;
    margin-left: 8vw;
    display: flex;
    height: 100%;
  }

  .menus-item {
    display: flex;
    align-items: center;
    margin-right: 60px;
    padding: 0 20px;
    height: 100%;
    border-bottom: 4px solid #fff;
    color: #020814;
    cursor: pointer;
  }

  .en-menu-item {
    margin-right: 180px;
  }

  .menus-box {
    padding-left: 17vw;
    margin-top: 7vh;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 99;
    color: #4E5969;
    font-size: 32px;
    height: 20vh;
  }

  .tabs {
    padding: 1vw 0;
    margin-right: 8vw;
  }

  .tab {
    margin-bottom: 0.5vh;
    padding: 0.5vw 5vw 0.5vw 2vw;
    cursor: pointer;
    border-radius: 16px;
  }

  .tab-active {
    color: #0F46FF;
    font-weight: 600;
    background-color: #F7F8FA;
  }

  .content {
    display: flex;
    text-align: left;
  }

  .box1 {
    margin-right: 9vw;
  }

  .box1 .title {
    padding: 0.5vw 0;
    font-size: 32px;
    font-weight: 550;
    color: #020814;
    border-bottom: 2px solid #F2F3F5;
  }

  .box1 .dec {
    margin-top: 0.1vw;
  }

  .box1 .item {
    padding: 0.5vw 0;
    cursor: pointer;
  }

  .tab:hover {
    background-color: #F7F8FA;
  }

  .link {
    display: flex;
    align-items: center;
  }

  .link:hover {
    font-weight: 600;
    color: #0F46FF;
    cursor: pointer;
  }

  .active {
    font-weight: 550;
    color: #0F46FF;
    border-bottom: 8px solid #0F46FF;
    box-sizing: content-box;
  }

  .top-icon {
    margin-right: 1vw;
  }

  .footer {
    padding: 0 12.5vw 0;
    height: 32.1vh;
    background: #020814;
    font-weight: 400;
    font-size: 28px;
    color: rgba(255, 255, 255, 0.5);
    line-height: 58px;

    &-top {
      display: flex;
      justify-content: space-between;
      padding-top: 5.6vh;
      padding-bottom: 1.5vh;
      min-height: 22.2vh;
      border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    }

    &-top-left {
      padding-right: 160px;
    }

    &-title {
      margin-bottom: 2.4vh;
      font-weight: 500;
      font-size: 28px;
      color: #fff;
    }

    &-label {
      padding-left: 30px;
      color: rgba(255, 255, 255, 1)
    }

    &-bot {
      padding-top: 30px;
      text-align: center;

    }

    &-beian {
      margin-right: 14px;
      width: 32px;
      height: 34px;
      vertical-align: -6px;
    }

    .wx-img {
      width: 172px;
      height: 172px;
    }
  }

  /* 移动端样式开始 */
  .mobile-active {
    font-weight: 500;
    color: #0F46FF;
  }

  .mobile-logo {
    margin-right: 60px;
    width: 136px;
    height: auto;
  }
  .mobile-code{
    width: 26vw;
  }

  .mobile-menus-btn {
    margin-left: auto;
    margin-right: 40px;
    width: 64px;
    height: 64px;
    background: url('./assets/images/menu.png') center no-repeat;
    background-size: contain;
  }

  .mobile-menus {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-wrap: wrap;
    padding-top: 7.4vh;
    width: 100%;
    height: 7vh;
    background: rgba(255, 255, 255);
    z-index: 9999;
    transition: all 0.3s ease-in-out 0s;
    overflow: hidden;
  }

  .opened-menus {
    height: 22vh;
  }

  .mobile-menus-item {
    width: 32%;
    line-height: 6.6vh;
    text-align: center;
  }

  /* 热线 */
  .service-box {
    position: fixed;
    right: 114px;
    bottom: 240px;
    padding-top: 70px;
    width: 120px;
    height: 120px;
    text-align: center;
    font-size: 24px;
    color: #4E5969;
    border-radius: 16px;
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.05);
    background: #fff url(./assets/images/tel.png) no-repeat center 16px;
    background-size: 48px 48px;
    cursor: pointer;
  }

  .service-box:hover {
    font-weight: 500;
    color: #0F46FF;
    background: #fff url(./assets/images/tel-active.png) no-repeat center 16px;
    background-size: 48px 48px;
  }

  .service-tel {
    position: fixed;
    right: 260px;
    bottom: 240px;
    padding: 0 40px;
    height: 120px;
    color: #020814;
    font-size: 36px;
    font-weight: 500;
    background: #fff;
    border-radius: 16px;
    transform: scale(0);
    transition: all 0.3s;
  }

  .service-box:hover+.service-tel {
    transform: scale(1);
  }
  .flex-box{
    display: flex;
    align-items: center;
  }
</style>